module.exports = __webpack_public_path__ + "static/media/bar2.cf04d2c7.svg";